export default "__VITE_ASSET__bb19b929__"